// src/store.js
import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
  state: {
    isLoggedIn: localStorage.getItem('loggedIn') === 'true',
  	first_name: localStorage.getItem('first_name'),
    middle_name: '',
    last_name: '',
    company_id: localStorage.getItem('company_id'),
    company_name: localStorage.getItem('company_name') || '',
    branch_id: localStorage.getItem('branch_id') === 'null' ? null : localStorage.getItem('branch_id'),
    branch_name: localStorage.getItem('branch_name') || '',
    user_pic: localStorage.getItem('user_pic'),
    role_name: localStorage.getItem('role_name') || '', // shown under the name in the sidebar
    tokenExpirationTime: '',
    latitude: null,
    longitude: null,
    permissions: JSON.parse(localStorage.getItem("permissions")) || [],
    modules: JSON.parse(localStorage.getItem("modules")) || [], // modules switched on for the active company
    is_platform: localStorage.getItem("is_platform") === "true", // active company is the platform company
  },
  mutations: {
    setLatitude(state, latitude) {
    state.latitude = latitude;
      console.log('Latitude committed to store:', state.latitude); // Check this!
    },
    setLongitude(state, longitude) {
      state.longitude = longitude;
    },
    SET_TOKEN_EXPIRATION(state, time){
      state.tokenExpirationTime = time;
    },
    SET_LOGGED_IN(state, status){
      state.isLoggedIn = status;
      localStorage.setItem('loggedIn', status);
    },
    /*setLoggedInDetails(state, data){
      state.isLoggedIn = data.isLoggedIn;
    },*/
    setUserDetails(state, data) {
       state.isLoggedIn = true;
       state.company_id = data.user.company_id ?? state.company_id;
       state.company_name = data.user.company_name ?? state.company_name;
       state.branch_id = data.user.branch_id;
       state.branch_name = data.user.branch_name ?? state.branch_name;

       state.first_name = data.user.first_name ?? state.first_name;
       state.middle_name = data.user.middle_name ?? state.middle_name;
       state.last_name = data.user.last_name ?? state.last_name;
       state.user_pic = data.user.user_pic ?? state.user_pic;
       state.role_name = data.user.role_name ?? state.role_name;
       //state.tokenExpirationTime = data.user.tokenExpirationTime ?? state.tokenExpirationTime;

       // Persist user details
       localStorage.setItem('company_id', state.company_id);
       localStorage.setItem('company_name', state.company_name);
       localStorage.setItem('branch_id', state.branch_id);
       localStorage.setItem('branch_name', state.branch_name);

       localStorage.setItem('first_name', state.first_name);
       localStorage.setItem('user_pic', state.user_pic);
       localStorage.setItem('role_name', state.role_name || '');
    },
  	/*setUserDetails(state, data){
      state.isLoggedIn = true;
  		state.first_name = data.user.first_name;
      state.middle_name = data.user.middle_name;
      state.last_name = data.user.last_name;
      state.user_pic = data.user.user_pic;
      state.tokenExpirationTime = data.user.tokenExpirationTime;
  	},*/
    /*setUserPic(state, userPic) {
       state.user_pic = userPic;
       localStorage.setItem('user_pic', userPic);
    },*/
    SET_IS_PLATFORM(state, value) {
      state.is_platform = !!value;
      localStorage.setItem("is_platform", state.is_platform);
    },
    SET_PERMISSIONS(state, data) {
      state.permissions = data;
      localStorage.setItem("permissions", JSON.stringify(data));
    },
    SET_MODULES(state, data) {
      state.modules = Array.isArray(data) ? data : [];
      localStorage.setItem("modules", JSON.stringify(state.modules));
    },
  	setOther(state, data){
  		//state.firstName = data;
  	}
  },
  actions: {
  	async retriveUserDetails({ commit }, router){
      const token = localStorage.getItem('jwt');
      const csrf_token = localStorage.getItem('csrf_token');
     if (token) {
       axios.get('/auth/verify.php', {
         headers: {
           Authorization: `Bearer ${token}`,
           'X-CSRF-TOKEN': csrf_token
         },
         withCredentials: true
       })
       .then((response) => {
         if (response.data.user) {
           localStorage.setItem('jwt', response.data.token); 
           commit('SET_LOGGED_IN', true);
           commit('SET_TOKEN_EXPIRATION', response.data.ex_time);
           //commit('setUserDetails', response.data);
         } else {
          //commit('setLoggedInDetails', { isLoggedIn: false });
          commit('SET_LOGGED_IN', false);
          localStorage.removeItem('jwt');
          localStorage.removeItem('csrf_token');
          localStorage.removeItem('loggedIn');
          sessionStorage.setItem('backend_message', response.data.message);
          sessionStorage.setItem('backend_alertType', "danger");
            router.push('/');
         }
       })
       .catch((error) => {
         console.error('Error verifying JWT', error);
       });
     } else {
       //this.$router.push('/');
     }
    }
  },
  getters: {
  	userName: function(state){
  		return `${state.firstName} ${state.lastName}`
  	}
  }
});

export default store;
